module.exports = "/_next/static/media/default-og-image.215fbb14.jpg";